import React from 'react';
import { useNavigate } from 'react-router-dom';
import SuiteQ from './assets/suite.jpg';
import SuiteC from './assets/suiteRouge.jpg';
import './aobergePage.css';

const AobergePage = () => {
  const navigate = useNavigate();

  const chambres = [
    {
      id: 1,
      type: "Suite Quadruple",
      description: "Appartement F2 de 45 m², idéal pour les familles ou les groupes de personnes. Il comprend un salon séparé, une literie haut de gamme, un téléviseur plasma avec chaînes câblées, le Wi-Fi gratuit, un réfrigérateur, un coffre-fort, une salle de bain privative, ainsi qu’un système de climatisation et de chauffage centralisés. Lits supplémentaires disponibles sur demande.",
      image: SuiteC,
      prix: "20000.00 DA/nuit",
      "option vue sur mer": "+ 2000.00 DA",
      "Réduction":"3eme et 4eme personnes -20% sur le tarif de base"
    },
    {
      id: 2,
      type: "Suite Communicante",
      description: "Spacieuse chambre de 30 à 35,5 m² pouvant accueillir jusqu’à 4 personnes. Elle dispose d’un salon intégré, d’une literie haut de gamme, d’un téléviseur plasma, du Wi-Fi gratuit, d’un réfrigérateur, d’un coffre-fort, d’une salle de bain privative, ainsi que d’une climatisation et d’un chauffage centralisés. Lits supplémentaires disponibles sur demande.",
      image: SuiteQ,
      prix: "32400.00 DA/nuit",
      "option vue sur mer": "+ 2000.00 DA",
      "Réduction":"3eme et 4eme personnes -20% sur le tarif de base"
    },
  ];

  // Filtrer uniquement les types de chambre à conserver
  const chambresFiltrees = chambres.filter(chambre =>
    ["Suite Communicante", "Suite Quadruple",].includes(chambre.type)
  );

  const handleReserve = (type) => {
    navigate('/Reservation', { state: { type } });
  };

  return (
    <div className="chambres-listS">
  {chambresFiltrees.map((chambre) => (
    <div key={chambre.id} className="chambre-cardS">
      <div
        className="chambre-imageS"
        style={{ backgroundImage: `url(${chambre.image})` }}
      >
        <span className="prix-tag">{chambre.prix}</span>
      </div>
      <div className="chambre-content">
        <h3>{chambre.type}</h3>
        <p>{chambre.description}</p>
        <p className="option-vue"> Vu sur mer : {chambre["option vue sur mer"]}</p>
        <p className="option-vue"> Réduction : {chambre["Réduction"]}</p>
        <button className="reserver-btn" onClick={() => handleReserve(chambre.type)}>Réserver</button>
      </div>
    </div>
  ))}
</div>

  );
};

export default AobergePage;
